import i18n from "i18next"
import { API_BASE_URL } from "../lib/apiClient.js"
import { getClientHeaders } from "../lib/clientMeta.js"

export interface ErrorReportDetails {
  /** Raw technical detail sent to admins — not necessarily what the user sees. */
  message: string
  /** Short label identifying where this happened, e.g. "Candidaturas do canil". */
  context: string
  statusCode?: number
}

/** Best-effort: emails pawseum0@gmail.com with the error + current page. Never throws. */
export async function reportErrorToAdmins({ message, context, statusCode }: ErrorReportDetails): Promise<boolean> {
  try {
    const res = await fetch(`${API_BASE_URL}/api/errors/report`, {
      method: "POST",
      headers: { "Content-Type": "application/json", ...getClientHeaders() },
      body: JSON.stringify({
        message,
        context,
        statusCode,
        page: window.location.pathname + window.location.search,
      }),
    })
    return res.ok
  } catch {
    return false
  }
}

/** Turns a raw HTTP status into a short, non-technical label — still names the error type. */
export function friendlyStatusMessage(statusCode?: number): string {
  if (statusCode === 404) return i18n.t("errors:friendlyStatus.notFound")
  if (statusCode === 401 || statusCode === 403) return i18n.t("errors:friendlyStatus.forbidden")
  if (statusCode !== undefined && statusCode >= 500) return i18n.t("errors:friendlyStatus.server")
  return statusCode ? i18n.t("errors:friendlyStatus.withCode", { statusCode }) : i18n.t("errors:friendlyStatus.generic")
}
